import { render, staticRenderFns } from "./SupplierOrdersCompleted.vue?vue&type=template&id=64a94321&"
import script from "./SupplierOrdersCompleted.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports